import CastBanner from './CastBanner';

export default CastBanner;
